<template>
    <v-container class="footer-address white--text py-0 align-center">
        <v-row>
            <v-col cols="12" sm="9" class="left-footer text-center text-sm-left">
                <p class="mb-0 d-inline-flex">Městská část Praha 9</p>
                <v-chip
                        class="ml-2"
                        color="transparent"
                        text-color="white"
                >
                    <v-avatar left tile>
                        <img :src="require('../../assets/iconfinder-icon-location.svg')"/>
                    </v-avatar>
                    Sokolovská 14/324 180 49 Praha 9
                </v-chip>
                <v-chip
                        class="ml-2"
                        color="transparent"
                        text-color="white"
                >
                    <v-avatar left tile>
                        <img :src="require('../../assets/iconfinder-icon-email.svg')"/>
                    </v-avatar>
                    prazskyportal@praha9.cz
                </v-chip>
            </v-col>
            <v-col cols="12" sm="3" class="right-footer align-center d-flex justify-center justify-sm-end">
                <p class="mb-0 text-right body-2">
                    <a class="white--text no-decoration" href="/pdf/Prazskyportal_Obchodni podminky_14052020 .pdf" target="_blank">Obchodní podmínky</a>
                </p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'FooterAddress'
    }
</script>

<style lang="scss">
    .footer-address {
        .left-footer {
            background-color: #4b982b;
        }
        .no-decoration {
            text-decoration: none;
        }
        .right-footer {
            background-image: url('../../assets/vlna_zelena-modra.png'), linear-gradient(to right, #10529e, #10529e);
            background-repeat: no-repeat;
            background-size: contain;
            @media #{$pixel-less-phone} {
                background-image: none;
            }
        }
    }
</style>
